import { render, staticRenderFns } from "./list_item_vertical.vue?vue&type=template&id=5e60c8ea&"
import script from "./list_item_vertical.vue?vue&type=script&lang=js&"
export * from "./list_item_vertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\works\\private\\kurlakk\\site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e60c8ea')) {
      api.createRecord('5e60c8ea', component.options)
    } else {
      api.reload('5e60c8ea', component.options)
    }
    module.hot.accept("./list_item_vertical.vue?vue&type=template&id=5e60c8ea&", function () {
      api.rerender('5e60c8ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/web/vue/views/properties/list_item_vertical.vue"
export default component.exports